(() => {
  const source=document.currentScript?.dataset.familiesUrl;
  if(!source)return;
  let registry;
  const load=()=>registry ||= fetch(source).then(r=>{if(!r.ok)throw Error('Colour registry unavailable');return r.json();});
  if(customElements.get('z-colour-family'))return;
  customElements.define('z-colour-family',class extends HTMLElement {
    connectedCallback(){this.render();}
    async render(){
      let groups;
      try{groups=await load();}catch{return;}
      if(!this.isConnected||this.dataset.ready)return;
      const family=groups[this.dataset.handle];
      if(!family||family.length<2)return;
      if(this.dataset.surface==='product'&&this.closest('product-info')?.querySelector('.zico-ridar-family'))return;
      const links=document.createElement('div');links.className='z-colour-family__links';
      links.setAttribute('aria-label','Colours');
      const selected=family.find(e=>e.handle===this.dataset.handle&&String(e.variant)===this.dataset.variant)||family.find(e=>e.handle===this.dataset.handle&&e.color===this.dataset.color)||family.find(e=>e.handle===this.dataset.handle);
      for(const entry of family){
        const a=document.createElement('a');a.href=entry.url;a.title=entry.color;a.setAttribute('aria-label',entry.color);
        if(entry===selected)a.setAttribute('aria-current','true');
        if(entry.image){const image=document.createElement('img');const url=new URL(entry.image,location.href);url.searchParams.set('width','80');image.src=url.href;image.alt=entry.color;image.width=44;image.height=44;image.loading='lazy';a.append(image);}
        else{a.textContent=entry.color;a.style.borderRadius='0';a.style.width='auto';a.style.flexBasis='auto';}
        links.append(a);
      }
      if(this.dataset.surface==='product'){
        const label=document.createElement('div');label.className='form__label';
        label.append('Color: ');
        const value=document.createElement('span');value.dataset.selectedValue='';
        value.textContent=family.find(e=>e.handle===this.dataset.handle&&String(e.variant)===this.dataset.variant)?.color||family.find(e=>e.handle===this.dataset.handle)?.color||'';
        label.append(value);
        this.append(label);
      } else {
        const card=this.closest('product-component,.zv7-card');
        const image=card?.querySelector('.card__media .media > img,.zv7-card__primary');
        const secondary=card?.querySelector('.card__media .media > img:nth-child(2),.zv7-card__secondary');
        if(image){
          window.ZicoCardColours?.preview(card,image,secondary,[...links.children].map((control,i)=>({control,image:family[i].image})));
        }
      }
      this.append(links);this.dataset.ready='true';
      if(this.dataset.surface!=='product')window.ZicoCardColours?.compact(links,'a');
    }
  });
})();
